import { createAction } from '@reduxjs/toolkit';

type LogoutActionPayload = {
  reason?: 'idle';
};

export const logout = createAction<LogoutActionPayload | undefined>(
  'auth/logout'
);
